import {DEFAULT_XRAY_EXAM_STATEMENT} from '../constants/marketing-detail.constants';

export const resolveXrayExamStatement = (xrayExamFooterText?: string | null): string => {
  if (xrayExamFooterText === '') {
    return '';
  }
  const statement = xrayExamFooterText || DEFAULT_XRAY_EXAM_STATEMENT;
  return statement.endsWith('.') ? statement : `${statement}.`;
};
